<template>
    <div>
        <template>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-card class="borde-card" elevation="0">
                    <v-card-title class="pl-8 pt-7 pb-0">
                        <i class="material-icons-outlined icono">beenhere </i>
                        <div class="leyenda col-10 py-0" for="">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Contratos
                        </div>
                        <br>
                        <div class="leyendaGrafica col-12 pr-0 pl-15 py-0">
                            Entregados-faltantes
                        </div>
                    </v-card-title>
                    <v-card-text class="pa-1 pt-0 px-5">
                        <div
                            slot="widget-content"
                            id="chartContainer"
                            style="height:300px; width:100%; margin-bottom: 20px;"
                            v-if="showGrafica"
                        >
                            <v-chart
                                style="width:100%; height:300px; position:relative;"
                                :options="pastelContrato1"
                                :autoresize="true"
                                @mouseover="mouseover_contratos01"
                                @mouseout="mouseout_contratos01"
                            />
                        </div>
                        <div
                            slot="widget-content"
                            id="chartContainer"
                            style="height:300px; width:100%; margin-bottom: 20px;"
                            v-else
                        >
                            <v-chart
                                style="width:100%; height:300px; position:relative;"
                                :options="pastelSinDatos"
                                :autoresize="true"
                            />
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

             <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-card class="borde-card" elevation="0">
                    <v-card-title class="pl-8 pt-7 pb-0">
                        <i class="material-icons-outlined icono">beenhere </i>
                        <div class="leyenda col-10 py-0" for="">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Contratos
                        </div>
                        <br>
                        <div class="leyendaGrafica col-12 pr-0 pl-15 py-0">
                            Por estatus
                        </div>
                    </v-card-title>
                    <v-card-text class="pa-1 pt-0 px-5">
                        <div
                            slot="widget-content"
                            id="chartContainer"
                            style="height:300px; width:100%; margin-bottom: 20px;"
                            v-if="showGrafica"
                        >
                            <v-chart
                                style="width:100%; height:300px; position:relative;"
                                :options="pastelContrato2"
                                :autoresize="true"
                                @mouseover="mouseover_contratos02"
                                @mouseout="mouseout_contratos02"
                            />
                        </div>
                        <div
                            slot="widget-content"
                            id="chartContainer"
                            style="height:300px; width:100%; margin-bottom: 20px;"
                            v-else
                        >
                            <v-chart
                                style="width:100%; height:300px; position:relative;"
                                :options="pastelSinDatos"
                                :autoresize="true"
                            />
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-card class="borde-card" elevation="0">
                    <v-card-title class="pl-8 pt-7 pb-0">
                        <i class="material-icons-outlined icono">beenhere </i>
                        <div class="leyenda col-10 py-0" for="">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Contratos
                        </div>
                        <br>
                        <div class="leyendaGrafica col-12 pr-0 pl-15 py-0">
                           Por tipo de contrato
                        </div>
                    </v-card-title>
                    <v-card-text class="pa-1 pt-0 px-5">
                        <div
                            slot="widget-content"
                            id="chartContainer"
                            style="height:300px; width:100%; margin-bottom: 20px;"
                            v-if="showGrafica"
                        >
                            <v-chart
                                style="width:100%; height:300px; position:relative;"
                                :options="pastelContrato3"
                                :autoresize="true"
                                @mouseover="mouseover_contratos03"
                                @mouseout="mouseout_contratos03"
                            />
                        </div>
                        <div
                            slot="widget-content"
                            id="chartContainer"
                            style="height:300px; width:100%; margin-bottom: 20px;"
                            v-else
                        >
                            <v-chart
                                style="width:100%; height:300px; position:relative;"
                                :options="pastelSinDatos"
                                :autoresize="true"
                            />
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-card class="borde-card" elevation="0">
                    <v-card-title class="pl-8 pt-7 pb-0">
                        <i class="material-icons-outlined icono">beenhere </i>
                        <div class="leyenda col-10 py-0" for="">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Contratos
                        </div>
                        <br>
                        <div class="leyendaGrafica col-12 pr-0 pl-15 py-0">
                           Por tipo de contrato
                        </div>
                    </v-card-title>
                    <v-card-text class="pa-1 pt-0 px-5">
                        <div
                            slot="widget-content"
                            id="chartContainer"
                            style="height:900px; width:100%; margin-bottom: 20px;"
                            v-if="showGrafica"
                        >
                            <v-chart
                                style="width:100%; height:900px; position:relative;"
                                :options="barrasContratos"
                                :autoresize="true"
                            />
                        </div>
                        <div
                            slot="widget-content"
                            id="chartContainer"
                            style="height:300px; width:100%; margin-bottom: 20px;"
                            v-else
                        >
                            <v-chart
                                style="width:100%; height:300px; position:relative;"
                                :options="pastelSinDatos"
                                :autoresize="true"
                            />
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </template>
    </div>
</template>

<script>
import ECharts from "vue-echarts";
import * as echarts from "../../node_modules/echarts/";
export default {
    components: {
        "v-chart": ECharts,
    },
    data() {
        return {
            showGrafica: true,
            pastelSinDatos: {
                series: [
                    {
                        legendHoverLink: false, //para desactivar el hover en la leyenda
                        selectedMode:false,
                        name    : "Contratos",
                        type    : "pie",
                        radius  : ["50%", "70%"],
                        center  : ["50%", "50%"],
                        label   : {
                            normal  : {
                                show    : true,
                                position: "center",
                                formatter   : (params) => {
                                    return "{top| Total}" + "\n" + "{bottom|0%}";
                                },
                                rich: {
                                    top: {
                                        color       : "#96999A",
                                        fontSize    : 12,
                                        fontWeight  : 400,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                    },
                                    bottom: {
                                        color       : "#96999A",
                                        fontSize    : 40,
                                        fontWeight  : 600,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                        padding     : [0, 0, 0, 5],
                                    },
                                },
                            },
                            emphasis: {
                                show    : true,
                                formatter: (params) => {
                                    return ("\n" + "{top| Total}" + "\n" + "{bottom|0%}");
                                },
                                rich: {
                                    top: {
                                        color       : "#96999A",
                                        fontSize    : 12,
                                        fontWeight  : 400,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                    },
                                    bottom: {
                                        color       : "#96999A",
                                        fontSize    : 40,
                                        fontWeight  : 600,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                        padding     : [0, 0, 0, 5],
                                    },
                                },
                            },
                        },
                        labelLine: {
                            normal: {
                                show: false,
                            },
                        },
                        itemStyle:{
                            emphasis:{
                                shadowBlur:0,
                                shadowOffsetX:0,
                                shadowColor:'rgba(0,0,0,0.5)',
                                color:"#EFEFEF"
                            }
                        },
                        data: [ {value: 1, name: "Total",}],
                        color: ["#EFEFEF"],
                    },
                ],
            },

            pastelContrato1: {
                tooltip : {
                    trigger : "item",
                    //formatter: "{a} </br>{b} : {c}({d}%)"
                    formatter: function(parms) {
                        var str =
                            `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${parms.color};"></span>` +
                            parms.data.name +
                            "</br>" +
                            "Total：" +
                            parms.data.value +
                            "</br>";
                        return str;
                    },
                },
                legend: {
                    icon    : "circle",
                    orient  : "horizontal",
                    type    : "scroll",
                    y       : "bottom",
                    text    : "top",
                    textStyle       : {
                        fontSize    : 12,
                        fontWeight  : 500,
                        fontFamily  : "Montserrat",
                        fontStyle   : "normal",
                        color       : "#96999A",
                    },
                },
                series: [
                    {
                        legendHoverLink: false, //para desactivar el hover en la leyenda
                        name    : "Contratos1",
                        type    : "pie",
                        radius  : ["50%", "70%"],
                        center  : ["50%", "50%"],
                        label   : {
                            normal  : {
                                show    : true,
                                position: "center",
                                formatter   : (params) => {
                                    return "{top| Contratos1}" + "\n" + "{bottom|100%}";
                                },
                                rich: {
                                    top: {
                                        color       : "#96999A",
                                        fontSize    : 12,
                                        fontWeight  : 400,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                    },
                                    bottom: {
                                        color       : "#96999A",
                                        fontSize    : 40,
                                        fontWeight  : 600,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                        padding     : [0, 0, 0, 5],
                                    },
                                },
                            },
                            emphasis: {
                                show    : true,
                                formatter: (params) => {
                                    return ("\n" + "{top| " + params.data.name +"}" + "\n" + "{bottom|" + params.percent + "%}");
                                },
                                rich: {
                                    top: {
                                        color       : "#96999A",
                                        fontSize    : 12,
                                        fontWeight  : 600,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                    },
                                    bottom: {
                                        color       : "#96999A",
                                        fontSize    : 40,
                                        fontWeight  : 600,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                        padding     : [0, 0, 0, 5],
                                    },
                                },
                            },
                        },
                        labelLine: {
                            normal: {
                                show: false,
                            },
                        },
                        
                        itemStyle: {
                            normal: {
                                borderWidth: 2,
                                borderColor: "#fff",
                            },
                        },
                        //data: [],
                        //color: [],
                        data:[
                            {value: 10, name: "Entregados",},
                            {value: 20, name: "Faltantes",}
                        ],
                        color:  [ 
                                '#17B5FE','#F7CA18','#C2E860','#F8690E','#FF4E71',
                                '#4FD2E0','#03E179','#035BFF','#5F5C61','#0A9D0A',
                                '#771919','#14C6B5','#3879F2','#2959B2','#5DB5D6',
                                '#427E98','#264957','#2959B2','#6B4539','#F79F86',
                                '#BBB09F','#7B7469','#633A3B','#F27951','#F08D90',
                                '#BFBFBF','#404040','#839B49','#6D8236','#F318A5',
                                '#9EA884','#DAE8B6','#E6F5C0','#C2CFA3','#646019',
                                '#F1E640','#B1AA2E'
                                ]
                    },
                ],
            },

            pastelContrato2: {
                tooltip : {
                    trigger : "item",
                    //formatter: "{a} </br>{b} : {c}({d}%)"
                    formatter: function(parms) {
                        var str =
                            `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${parms.color};"></span>` +
                            parms.data.name +
                            "</br>" +
                            "Total：" +
                            parms.data.value +
                            "</br>";
                        return str;
                    },
                },
                legend: {
                    icon    : "circle",
                    orient  : "horizontal",
                    type    : "scroll",
                    y       : "bottom",
                    text    : "top",
                    textStyle       : {
                        fontSize    : 12,
                        fontWeight  : 500,
                        fontFamily  : "Montserrat",
                        fontStyle   : "normal",
                        color       : "#96999A",
                    },
                },
                series: [
                    {
                        legendHoverLink: false, //para desactivar el hover en la leyenda
                        name    : "Contratos2",
                        type    : "pie",
                        radius  : ["50%", "70%"],
                        center  : ["50%", "50%"],
                        label   : {
                            normal  : {
                                show    : true,
                                position: "center",
                                formatter   : (params) => {
                                    return "{top| Contratos2}" + "\n" + "{bottom|100%}";
                                },
                                rich: {
                                    top: {
                                        color       : "#96999A",
                                        fontSize    : 12,
                                        fontWeight  : 400,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                    },
                                    bottom: {
                                        color       : "#96999A",
                                        fontSize    : 40,
                                        fontWeight  : 600,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                        padding     : [0, 0, 0, 5],
                                    },
                                },
                            },
                            emphasis: {
                                show    : true,
                                formatter: (params) => {
                                    return ("\n" + "{top| " + params.data.name +"}" + "\n" + "{bottom|" + params.percent + "%}");
                                },
                                rich: {
                                    top: {
                                        color       : "#96999A",
                                        fontSize    : 12,
                                        fontWeight  : 600,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                    },
                                    bottom: {
                                        color       : "#96999A",
                                        fontSize    : 40,
                                        fontWeight  : 600,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                        padding     : [0, 0, 0, 5],
                                    },
                                },
                            },
                        },
                        labelLine: {
                            normal: {
                                show: false,
                            },
                        },
                        
                        itemStyle: {
                            normal: {
                                borderWidth: 2,
                                borderColor: "#fff",
                            },
                        },
                        //data: [],
                        //color: [],
                        data:[
                            {value: 10, name: "Listos para entregar"},
                            {value: 20, name: "Vencidos"},
                            {value: 10, name: "Incompletos"},
                            {value: 20, name: "Cancelados"},
                            {value: 10, name: "Firmados"},
                            {value: 20, name: "Pendientes por renovar"}
                        ],
                        color:  [ 
                                '#17B5FE','#F7CA18','#C2E860','#F8690E','#FF4E71',
                                '#4FD2E0','#03E179','#035BFF','#5F5C61','#0A9D0A',
                                '#771919','#14C6B5','#3879F2','#2959B2','#5DB5D6',
                                '#427E98','#264957','#2959B2','#6B4539','#F79F86',
                                '#BBB09F','#7B7469','#633A3B','#F27951','#F08D90',
                                '#BFBFBF','#404040','#839B49','#6D8236','#F318A5',
                                '#9EA884','#DAE8B6','#E6F5C0','#C2CFA3','#646019',
                                '#F1E640','#B1AA2E'
                                ]
                    },
                ],
            },

            pastelContrato3: {
                tooltip : {
                    trigger : "item",
                    //formatter: "{a} </br>{b} : {c}({d}%)"
                    formatter: function(parms) {
                        var str =
                            `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${parms.color};"></span>` +
                            parms.data.name +
                            "</br>" +
                            "Total：" +
                            parms.data.value +
                            "</br>";
                        return str;
                    },
                },
                legend: {
                    icon    : "circle",
                    orient  : "horizontal",
                    type    : "scroll",
                    y       : "bottom",
                    text    : "top",
                    textStyle       : {
                        fontSize    : 12,
                        fontWeight  : 500,
                        fontFamily  : "Montserrat",
                        fontStyle   : "normal",
                        color       : "#96999A",
                    },
                },
                series: [
                    {
                        legendHoverLink: false, //para desactivar el hover en la leyenda
                        name    : "Contratos3",
                        type    : "pie",
                        radius  : ["50%", "70%"],
                        center  : ["50%", "50%"],
                        label   : {
                            normal  : {
                                show    : true,
                                position: "center",
                                formatter   : (params) => {
                                    return "{top| Contratos3}" + "\n" + "{bottom|100%}";
                                },
                                rich: {
                                    top: {
                                        color       : "#96999A",
                                        fontSize    : 12,
                                        fontWeight  : 400,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                    },
                                    bottom: {
                                        color       : "#96999A",
                                        fontSize    : 40,
                                        fontWeight  : 600,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                        padding     : [0, 0, 0, 5],
                                    },
                                },
                            },
                            emphasis: {
                                show    : true,
                                formatter: (params) => {
                                    return ("\n" + "{top| " + params.data.name +"}" + "\n" + "{bottom|" + params.percent + "%}");
                                },
                                rich: {
                                    top: {
                                        color       : "#96999A",
                                        fontSize    : 12,
                                        fontWeight  : 600,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                    },
                                    bottom: {
                                        color       : "#96999A",
                                        fontSize    : 40,
                                        fontWeight  : 600,
                                        fontFamily  : "Montserrat",
                                        fontStretch : "normal",
                                        fontStyle   : "normal",
                                        letterSpacing: "normal",
                                        padding     : [0, 0, 0, 5],
                                    },
                                },
                            },
                        },
                        labelLine: {
                            normal: {
                                show: false,
                            },
                        },
                        
                        itemStyle: {
                            normal: {
                                borderWidth: 2,
                                borderColor: "#fff",
                            },
                        },
                        //data: [],
                        //color: [],
                        data:[
                            {value: 10, name: "Contrato indeterminado",},
                            {value: 20, name: "Contrato de trabajo para obra determinada",},
                            {value: 10, name: "Contato determinado",},
                            {value: 20, name: "Contrato de trabajo por temporada",},
                            {value: 10, name: "Contrato de trabajo sujeto a prueba",},
                            {value: 20, name: "Contrato de trabajo con capacitación inicial",},
                            {value: 10, name: "Modalidad de trabajo por comisión laboral",},
                            {value: 20, name: "Modalidadades de contratación donde no existe relación de trabajo",},
                            {value: 10, name: "Jubilación, pensión, retiro",},
                            {value: 10, name: "Otro contrato",},
                        ],
                        color:  [ 
                                '#17B5FE','#F7CA18','#C2E860','#F8690E','#FF4E71',
                                '#4FD2E0','#03E179','#035BFF','#5F5C61','#0A9D0A',
                                '#771919','#14C6B5','#3879F2','#2959B2','#5DB5D6',
                                '#427E98','#264957','#2959B2','#6B4539','#F79F86',
                                '#BBB09F','#7B7469','#633A3B','#F27951','#F08D90',
                                '#BFBFBF','#404040','#839B49','#6D8236','#F318A5',
                                '#9EA884','#DAE8B6','#E6F5C0','#C2CFA3','#646019',
                                '#F1E640','#B1AA2E'
                                ]
                    },
                ],
            },

            barrasContratos:{
                xAxis:{
                    //type:'category',
                    data: [ 
                        "Contrato indeterminado",
                        "Contrato de trabajo para obra determinada",
                        "Contato determinado",
                        "Contrato de trabajo por temporada",
                        "Contrato de trabajo sujeto a prueba",
                        "g",
                        "h",
                        "i",
                        "j",
                        "k"
                    ],
                    axisLabel:{
                        //interval:0,
                        color:'#000',
                        fontSize: 10,
                        rotate:90,
                        verticalAlign: 'top',
                        inside:true
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    z: 10
                },
                grid:{
                    right: '28%',
                    left: '8%',
                    bottom: '8%',
                    top: '8%'
                },
                legend:{
                    icon: 'circle',
                    orient: 'vertical',
                    type: 'scroll',
                    right: 110,
                    height: 250,
                    whidth: 150,
                    top: 100,
                    itemGap: 20,
                    textStyle:{
                        fontSize    : 14,
                        fontWeight  : 500,
                        fontFamily  : 'Montserrat',
                        fontStyle   : '#57575C'
                    },
                },
                yAxis:{
                    type:'value',
                },
                dataZoom:[
                    {
                        type: 'inside'
                    }
                ],
                series:[{
                    data:[
                        {
                            value: 470,
                            itemStyle: {
                                color: '#1C1D65'
                            }
                        },
                        {
                            value: 43022,
                            itemStyle: {
                                color: '#1C4C88'
                            }
                        },
                        {
                            value: 42000,
                            itemStyle: {
                                color: '#1A79AC'
                            }
                        },
                        {
                            value: 45022,
                            itemStyle: {
                                color: '#1A92B9'
                            }
                        },
                        {
                            value: 49000,
                            itemStyle: {
                                color: '#1AAAC7'
                            }
                        },
                        {
                            value: 43022,
                            itemStyle: {
                                color: '#54BCD0'
                            }
                        },
                        {
                            value: 47000,
                            itemStyle: {
                                color: '#8DCDD9'
                            }
                        },
                        {
                            value: 45022,
                            itemStyle: {
                                color: '#A4D4DD'
                            }
                        },
                        {
                            value: 46000,
                            itemStyle: {
                                color: '#BCDAE0'
                            }
                        },
                        {
                            value: 43022,
                            itemStyle: {
                                color: '#D3EFF4'
                            }
                        },
                    ],
                    type:'bar'
                }]
            },
        }
    },
    methods:{
        mouseover_contratos01(event, chartContext, config) {
            this.pastelContrato1.series[0].label.normal.show = false;
        },
        mouseout_contratos01(event, chartContext, config) {
            this.pastelContrato1.series[0].label.normal.show = true;
        },
        mouseover_contratos02(event, chartContext, config) {
            this.pastelContrato2.series[0].label.normal.show = false;
        },
        mouseout_contratos02(event, chartContext, config) {
            this.pastelContrato2.series[0].label.normal.show = true;
        },
        mouseover_contratos03(event, chartContext, config) {
            this.pastelContrato3.series[0].label.normal.show = false;
        },
        mouseout_contratos03(event, chartContext, config) {
            this.pastelContrato3.series[0].label.normal.show = true;
        },
    }


}
</script>

<style scoped>
    .echarts {
        width: 100%;
        height: 100%;
    }
    .icono {
        color: #2DB9D1;
    }
    
    .leyenda {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 29px;
        color: rgba(16, 28, 90);
    }
    .leyendaGrafica {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 12px;
        color: #828282;
    }
</style>